<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';

  import axios from 'axios';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'spare-parts',

    props: [
      'productID',
      'placeholder',
      'language'
    ],

    mounted() {
      this.fetchSpareParts();
    },

    data() {
      return {
        spareParts: [],

        search: ''
      }
    },

    computed: {
      filteredItems() {
        return this.spareParts.filter(item => {
          var searchString = item.name + ' ' + item.visma_product_no;

           return searchString.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        })
      }
    },

    methods: {
      fetchSpareParts() {
        var self = this;

        this.loading = true;

        axios.get('/api/v1/spareparts/product/' + this.productID + '/' + this.language)
        .then(function (response) {
          self.spareParts = response.data.data;
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;

          console.log("Error fetching spare parts: ", error);
        });
      },
    }
  };
</script>

<template>
  <div>
    <input type="text" v-model="search" :placeholder="placeholder" class="spare-search">

    <ul v-for="part in filteredItems">
      <li><a :href="part.product_url"><b>{{ part.name }}</b></a><br>{{ part.visma_product_no }}</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>

</style>
